import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const LABELS = {
  about: "About",
  contact: "Contact",
  services: "Services",
  divisions: "Divisions",
  "medical-center": "Infinity Medical Center",
  "medical-lab": "Infinity Medical Lab",
  "pharmacy-wellness": "Infinity Pharmacy & Wellness",
  projects: "Projects",
  industries: "Industries",
  "why-choose-us": "Why IMG",
  "clients-partners": "Clients & Partners",
  certifications: "Certifications",
  faq: "FAQ",
  news: "News",
  privacy: "Privacy",
  terms: "Terms",
};

const formatLabel = (slug) =>
  LABELS[slug] ||
  slug.split("-").map((s) => s[0]?.toUpperCase() + s.slice(1)).join(" ");

export default function Breadcrumbs({ overrideLast }) {
  const { pathname } = useLocation();
  if (pathname === "/") return null;
  const parts = pathname.split("/").filter(Boolean);
  const crumbs = parts.map((part, i) => ({
    label: i === parts.length - 1 && overrideLast ? overrideLast : formatLabel(part),
    href: "/" + parts.slice(0, i + 1).join("/"),
  }));

  const ld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://infinitymg.so/" },
      ...crumbs.map((c, i) => ({
        "@type": "ListItem",
        position: i + 2,
        name: c.label,
        item: `https://infinitymg.so${c.href}`,
      })),
    ],
  };

  return (
    <>
      <nav
        aria-label="Breadcrumb"
        data-testid="breadcrumbs"
        className="container pt-28 lg:pt-32 pb-2"
      >
        <ol className="flex flex-wrap items-center gap-1.5 text-xs text-navy-500">
          <li>
            <Link to="/" className="inline-flex items-center gap-1 hover:text-teal transition-colors">
              <Home className="h-3.5 w-3.5" /> Home
            </Link>
          </li>
          {crumbs.map((c, i) => (
            <li key={c.href} className="inline-flex items-center gap-1.5">
              <ChevronRight className="h-3 w-3 text-navy-300" />
              {i === crumbs.length - 1 ? (
                <span className="text-navy-800 font-medium">{c.label}</span>
              ) : (
                <Link to={c.href} className="hover:text-teal transition-colors">
                  {c.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script type="application/ld+json">{JSON.stringify(ld)}</script>
    </>
  );
}
